export default {
  SCORES_FIELD_REFERENCE_DATA_SET_STATE         : 'SCORES_FIELD_REFERENCE_DATA_SET_STATE',
  SCORES_FIELD_REFERENCE_DATA_TRIGGER_SET_STATE : 'SCORES_FIELD_REFERENCE_DATA_TRIGGER_SET_STATE',
  SCORES_FIELD_REFERENCE_DATA_FIELDIDS_SET_IDS  : 'SCORES_FIELD_REFERENCE_DATA_FIELDIDS_SET_IDS',
};